// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stepper-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n\n.stepper-stepper {\n  width: 90%;\n}\n\n.stepper-labelButton {\n  z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
